export default __webpack_public_path__ + "static/media/iforfetari.518a1b4a.png";